import { createAsyncThunk, createSlice, PayloadAction } from '@reduxjs/toolkit'
import { RootState } from '../../../app/store'
import fetchAPI from '../../../common/fetchAPI'
import { AccountPreferenceStateClass } from './interfaces/accountPreferenceStateClass';

const initialState: AccountPreferenceStateClass = {
    isLoading: true,
    status: 'idle',
    accountPreferenceDetail: [],
    selectedRecord: {},
    isReload: false,
    applicationMode: '',
    sessionAccountEmployeeId: 0,
    sessionAccountId: 0,
    accessToken: '',
    isloading: false
}

interface IThunkApi {
    state: {
        accountPreferences: AccountPreferenceStateClass;
        globalState: any;
    }
}

export const getDataAccountPreferenceFormAsync = createAsyncThunk
    <any, void, IThunkApi>
    (
        'accountPreferences/v2/getDataAccountPreferenceForm',
        async (arg, thunkApi) => {
            const { sessionAccountId, sessionAccountEmployeeId } = thunkApi.getState().globalState
            const response = await fetchAPI(`api/V2/AccountPreferences/getDataAccountPreferenceForm/${sessionAccountId}/${sessionAccountEmployeeId}`, 'Get', '', true, 'a73f036e-6d84-440b-85e0-70e157c5eef7');
            const json = await response.json();
            return json;
        }
    )

export const uploadLogo = createAsyncThunk
    <any, any, IThunkApi>
    (
        'accountPreferences/v2/uploadLogo',
        async (args, thunkApi) => {
            const { formData } = args;
            let response: any = "";
            response = await fetchAPI(`api/V2/AccountPreferences/UploadLogo`, 'POST', formData, true, 'cce1c985-3054-43d2-b262-0731a14f3ca8', true);
            const json = await response.json();
            return json;
        }
    )


export const UpdateAccountPreferencesAsync = createAsyncThunk
    <any, any, IThunkApi>
    (
        'accountPreferences/v2/UpdatePreferences',
        async (arg, thunkApi) => {
            const { AccountPreferencesId, AccountTypeId, AccountName, Address1, Address2, ZipCode, State, City, CountryId, EMailAddress, Telephone, Fax,
                DefaultCurrencyId, TimeZoneId, AccountExpiryActivation, IsTrakLiveAccount, SubDomain, URLReferrer, LicenseKey, LicenseActivation,
                Country, TimeZoneName, SystemTimeEntryHoursFormat, EnglishName, IsEmailVerified, dateInsertionFormat, customFieldInsertionFormat,
                IsShowEmployeeProfilePicture, AllowMoveTask, HighlightTimeEntriesBy,ProfileTimeZoneIANA,AccountEmployeeDashboardId,OpenInNewTab,ShowAdvanceBoard, ...argWithoutId } = arg;

            const accountObject = {
                AccountTypeId: AccountTypeId, AccountName: AccountName, Address1: Address1, Address2: Address2, ZipCode: ZipCode, State: State, City: City, CountryId: CountryId, EMailAddress: EMailAddress, Telephone: Telephone,
                Fax: Fax, DefaultCurrencyId: DefaultCurrencyId, TimeZoneId: TimeZoneId, AccountExpiryActivation: AccountExpiryActivation, IsTrakLiveAccount: IsTrakLiveAccount, SubDomain: SubDomain, URLReferrer: URLReferrer,
                LicenseKey: LicenseKey, LicenseActivation: LicenseActivation
            }
            const response = await fetchAPI('api/v2/AccountPreferences/UpdatePreferences/',
                'POST',
                { accountObject: accountObject, accountPreferenceObject: argWithoutId },
                true,
                'a73f036e-6d84-440b-85e0-70e157c5eef7');
            const json = await response.json();
            return json;
        }
    )


export const accountPreferenceSlice = createSlice({
    name: 'accountPreferences',
    initialState,
    reducers: {
        resetSelectedRecordObjectInState: (state) => {
            state.selectedRecord = {};
        },
        updateLoadingEffect: (state, action) => {
            state.isloading = action.payload;
        }
    },
    extraReducers: (builder) => {
        builder

            .addCase(getDataAccountPreferenceFormAsync.pending, (state) => {
                state.status = 'loading';
                state.isLoading = true;
            })
            .addCase(getDataAccountPreferenceFormAsync.fulfilled, (state, { payload }) => {

                state.status = 'idle';
                if (payload.data) {
                    if (Object.keys(payload.data).length === 0) {
                        state.accountPreferenceDetail = [];
                    } else {
                        state.accountPreferenceDetail = payload.data;
                        state.selectedRecord = payload.data[0];
                        state.applicationMode = payload.ApplicationMode;
                    }
                }
                state.isLoading = false;
                state.isReload = false;
            })
            .addCase(getDataAccountPreferenceFormAsync.rejected, (state) => {
                state.status = 'failed';
                state.isLoading = false;
            })

            .addCase(UpdateAccountPreferencesAsync.pending, (state) => {
                state.status = 'loading';
                state.isLoading = true;
            })
            .addCase(UpdateAccountPreferencesAsync.fulfilled, (state, { payload }) => {
                state.status = 'idle';
                state.isReload = true;
                state.isLoading = false;


            })
            .addCase(UpdateAccountPreferencesAsync.rejected, (state) => {
                state.status = 'failed';
                state.isLoading = false;
            })

            .addCase(uploadLogo.pending, state => {
                state.status = 'loading';
                state.isLoading = true;

            }).addCase(uploadLogo.fulfilled, (state, { payload }) => {
                state.status = 'idle';
                state.isLoading = false;

            }).addCase(uploadLogo.rejected, (state) => {
                state.status = 'failed';
                state.isLoading = false;
            })

    }
})
export const {
    resetSelectedRecordObjectInState, updateLoadingEffect
} = accountPreferenceSlice.actions
export const AccountPreferenceState = (state: RootState) => state.accountPreferences
export default accountPreferenceSlice.reducer